import { PriceMaximizerState } from '../../../@types/state-types'
import { PriceMaximizerResult } from '../../../@types/price-maximizer-types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: PriceMaximizerState = {
  savedSearches: undefined,
  similarObjects: undefined,
}
const priceMaximizerSlice = createSlice({
  name: 'priceMaximizerFeature',
  initialState,
  reducers: {
    priceMaximizerSuccess(state, action: PayloadAction<{ priceMaximizerResult: PriceMaximizerResult }>) {
      state.savedSearches = action.payload.priceMaximizerResult.savedSearches
      state.similarObjects = action.payload.priceMaximizerResult.similarObjects
    },
    priceMaximizerReset(state) {
      state.savedSearches = undefined
      state.similarObjects = undefined
    },
  },
})

export const { priceMaximizerSuccess, priceMaximizerReset } = priceMaximizerSlice.actions
export default priceMaximizerSlice.reducer
